import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=488a4492&"
import script from "./Timeline.vue?vue&type=script&lang=ts&"
export * from "./Timeline.vue?vue&type=script&lang=ts&"
import style0 from "./Timeline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports